/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)


import '../stylesheets/application';

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
const images = require.context('../images', true);
import Rails from 'rails-ujs';
import Turbolinks from 'turbolinks';

import { pascalToSnake } from '../utils';
import { headerSearch, progress, instant, captchaLoad, dropdown } from '../views';
import { consent } from '../tracking';

Rails.start();
Turbolinks.start();

window.query = document.querySelector.bind(document);
window.queryAll = document.querySelectorAll.bind(document);
window.globalListener = document.addEventListener.bind(document);

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(search, pos) {
    return this.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
  };
}

['DOMContentLoaded', 'turbolinks:load'].forEach(e => {
  document.addEventListener(e, () => {
    headerSearch();
    const body = document.querySelector('body');
    const instantDropdown = event => {
      event.preventDefault();
      const instantForm = query('#vf-instant-form');
      if (getComputedStyle(instantForm).display !== 'none') {
        instantForm.style.display = 'none';
      } else {
        instantForm.style.display = 'flex';
      }
    }
    queryAll('.vf-instant-trigger').forEach(trigger => trigger.addEventListener('click', event => instantDropdown(event)));

    dropdown();
    progress();
 // consent('#{url_for_i18n(:privacy_policy)}');
  window.vfInstantButtonCaptchaSubmit = instant({ isMobile: false });
  if (location.hostname !== 'lvh.me') {
     consent('#{url_for_i18n(:privacy_policy)}');
  window.onLoadCallback = captchaLoad;
  window.recaptchaSiteKey = body.dataset.recaptcha;
} else {
  instant({ isMobile: false});
  }


    const controller = pascalToSnake(body.dataset.controller);
    const action = body.dataset.action;
    const variant = body.dataset.variant;
    const namespaces = body.dataset.namespace ? body
      .dataset
      .namespace
      .split('::')
      .map(pascalToSnake) : []
console.log('VIEW LOAD', {
  controller,
  action,
  namespaces,
  path: location.pathname
});
    if (namespaces.length === 0) {
      import(`../views/${controller}`)
  .then(module => {
    const viewInitializer = module[`init${action}`];

    if (typeof viewInitializer === 'function') {
      const callback = viewInitializer({isMobile: variant === 'mobile'});

      if (controller === 'feedbacks' && typeof callback === 'function') {
        window.vfFeedbackButtonCaptchaSubmit = callback;
      }
    }
  })
  .catch(error => {
    if (error.message.includes('Cannot find module')) {
      return;
    }
    console.error(error);
  });
    } else {
      import(`../views/${namespaces.join('/')}/${controller}`).then(module => {
        const viewInitializer = module[`init${action}`];
        if (typeof viewInitializer === 'function') {
          viewInitializer({isMobile: variant === 'mobile'})
        }
      }).catch(error => console.log(error));
    }
  });
});
